import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'yat-external-link-on-hover',
  templateUrl: './external-link-on-hover.component.html',
  styleUrls: ['./external-link-on-hover.component.scss']
})
export class ExternalLinkOnHoverComponent {
  @Input()
  id: string;

  @Input()
  link: string | null = null;

  @Input()
  linkName: string;

  @Input()
  tooltipText: string;

  @Input()
  tooltipClass: string = 'tooltip-xl';

  @ViewChild('linkElement', { static: true }) linkElement: ElementRef<HTMLAnchorElement>;

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.linkElement.nativeElement.click();
    }
  }
}
